import { createMachine, assign } from 'xstate';
import logger from '../../logger';

export const paletteMachine = createMachine({
  predictableActionArguments: true,
  id: 'palette',

  // Initial state
  initial: 'inactive',

  // Local context for entire machine
  context: {
    paletteType: null,
  },

  // State definitions
  states: {
    inactive: {
      on: {
        TOGGLE: {
          target: 'active',
          entry: assign((context, event) => {
            logger.log('inactive - toggle');
          }),
        },
      },
    },
    active: {
      on: {
        TOGGLE: {
          target: 'inactive',
          entry: assign((context, event) => {
            console.log('active - toggle');
          }),
        },
      },
    },
  },
});
